import React from 'react';

export default function HomeStats() {
  return (
    <section className="stats" aria-label="DALMAF trust indicators">
      <div>
        <strong className="stat-value">30+</strong>
        <span className="stat-label">Years Industry Experience</span>
      </div>
      <div>
        <strong className="stat-value">100%</strong>
        <span className="stat-label">Legal Compliance Focus</span>
      </div>
      <div>
        <strong className="stat-value">100%</strong>
        <span className="stat-label">Audit Service Discipline</span>
      </div>
      <div>
        <strong className="stat-value">100%</strong>
        <span className="stat-label">Human Resource Support</span>
      </div>
    </section>
  );
}
